export default __webpack_public_path__ + "static/media/LMU_Logo.11adabc7.svg";